var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"col-12",class:( _obj = {}, _obj[("col-md-" + _vm.colWidth)] = _vm.colWidth, _obj )},[(_vm.slotName)?_vm._t("default"):_c('TextSection',_vm._b({},'TextSection',{ title: _vm.title, description: _vm.description },false))],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }